

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class FileItem_ManagedObject

class FileItem_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: entityID
    set entityID(value:string) {
        this.setValueForKey(value, 'entityID');
    }
    get entityID():string {
        return this.valueForKey('entityID');
    }
    set entityIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'entityID');
    }
    get entityIDPrimitiveValue():string {
        return this.primitiveValueForKey('entityID');
    }

    // Property: entityType
    set entityType(value:string) {
        this.setValueForKey(value, 'entityType');
    }
    get entityType():string {
        return this.valueForKey('entityType');
    }
    set entityTypePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'entityType');
    }
    get entityTypePrimitiveValue():string {
        return this.primitiveValueForKey('entityType');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }
}
